export default "__VITE_ASSET__af9dbea2__"